import router from './../router';

window.axios = require('axios');
window.axios.defaults.baseURL = process.env.API_URL;
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// Verificando si existe el usuario
const user = localStorage.getItem('user');
if (user) {
  const user_token = JSON.parse(user).token;
  window.axios.defaults.headers.common['Authorization'] = user_token;
}

window.axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  const status = error.response.status;
  const data = error.response.data;
  if (status === 401) {
    window.getApp.$emit('APP_AUTH_FAILED');
  } else if (status === 422) {
    window.getApp.$emit('APP_VALIDATIONS_ERRORS', 'Some data is not correct');
  } else if (status === 400) {
    if (data.hasOwnProperty('type')) {
      if (data.type === 'LOGIN') {
        window.getApp.$emit('APP_INCORRECT_LOGIN', data.error);
      }
    }
  } else if (status === 404) {
    router.push('/surveys');
  } else if (status === 500) {
    if (data.hasOwnProperty('message')) {
      window.getApp.$emit('APP_SHOW_MESSAGE_ERROR', data.message);
    }
  }
  return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/util/axios.js